import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { rfqService } from '../../../shared/api/services/rfq.service'


export const useRFQs = () => {
    const [searchText, setSearchText] = useState('')
    const [activeTab, setActiveTab] = useState('all')

    // Prepare query parameters
    const queryParams = {
        search: searchText || undefined,
        status: activeTab !== 'all' ? activeTab : undefined,
    }

    // Fetch RFQs using TanStack Query
    const { 
        data: rfqResponse, 
        isLoading, 
        error 
    } = useQuery({
        queryKey: ['rfqs', queryParams],
        queryFn: () => rfqService.getAll(queryParams),
        // Keep previous data while fetching new data for smoother transitions
        placeholderData: (previousData) => previousData,
    })

    const rfqs = rfqResponse?.data || []

    return {
        rfqs,
        isLoading,
        error,
        searchText,
        setSearchText,
        activeTab,
        setActiveTab
    }
}
